<script lang="ts" setup>
defineProps<{
  page?: boolean
}>()
</script>

<template>
  <div
    class="px-5 mx-auto w-full max-w-[1440px] lg:px-12" :class="[
      {
        'pt-6 pb-10 lg:pt-10 lg:pb-25': page,
      },
    ]"
  >
    <slot />
  </div>
</template>
